import { Component, input, model, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioButtonComponent } from '@sp-client/app/components/radio-button/radio-button.component';
import { ProperTitleCasePipe } from '@sp-client/app/pipes/proper-title-case.pipe';
import { RadioButtonOption } from '@sp-client/app/interfaces/radio-button-option.interface';

@Component({
	selector: 'sp-radio-button-list',
	standalone: true,
	imports: [CommonModule, RadioButtonComponent, ProperTitleCasePipe],
	templateUrl: './radio-button-list.component.html',
	styleUrl: './radio-button-list.component.scss'
})
export class RadioButtonListComponent {
	// Inputs
	options = input<RadioButtonOption[]>([]);

	// Two-way binding model
	selectedValue = model<string>('');

	// Outputs
	errorState = output<boolean>();

	/**
	 * Validate if a selection has been made
	 * @returns true if valid (selection made), false if invalid (no selection)
	 */
	validateSelection(): boolean {
		const isValid = !!this.selectedValue();
		this.errorState.emit(!isValid);
		return isValid;
	}

	/**
	 * Select an option and clear any error state
	 * @param value The value of the option to select
	 */
	selectOption(value: string): void {
		this.selectedValue.set(value);
		this.errorState.emit(false); // Clear error on selection
	}
}
